import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { backgroundImageStyle, fontSize } from '@css/styles'
import {
  cdnUrl,
  darkRed,
  white,
  MQ, black, radiantBlue, marketingMobileCuttoff,
} from '@css/constants'
import {LeadgenPopupType} from "@components/LeadgenPopupFlow";

export type HeroSectionWrapperProps = {
  centered?: boolean
}

export const HeroSectionWrapper = styled('div')<HeroSectionWrapperProps>(props => css`
  display: flex;
  position: relative;
  padding: ${props.centered ? '0' : '43px 0 0'};
  height: 540px;
  box-sizing: border-box;

  ${MQ.SMALL_SCREENS} {
    flex-direction: column;
    padding-top: 0;
    padding-bottom: 40px;
    height: auto;
  }
`)

export const InnerContent = styled('div')<HeroSectionWrapperProps>(props => css`
  width: 90%;
  max-width: 1000px;
  margin: 0 auto;
  z-index: 1;
  align-self: ${props.centered ? 'center' : ''};

  ${MQ.SMALL_SCREENS} {
    margin-top: 20px;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
  }
`)

type ImgProps = {
  mobileSrc: string
  desktopSrc: string
}

export const BackgroundImage = styled('div')<ImgProps>(props => css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${white};
  background-image: ${cdnUrl(props.desktopSrc)};
  ${backgroundImageStyle};
  background-size: cover;

  ${MQ.SMALL_SCREENS} {
    background-image: ${cdnUrl(props.mobileSrc)};
    position: relative;
    height: 227px;
  }
`)

export const FormWrapper = styled('form')(css`
  max-width: 327px;
  margin-top: 30px;

  ${MQ.SMALL_SCREENS} {
    margin: 22px auto 0;
  }
`)

export const FormQuestionWrapper = styled('div')(css`
  position: relative;
  width: 100%;
`)

export const Title = styled('h1')<HeroTextProps>(props => css`
  ${FontNormal(600)};
  font-size: 48px;
  max-width: 721px;
  width: ${props.titleWidth ? `${props.titleWidth}` : ''};

  sup {
    font-size: 14px;
  }

  ${MQ.SMALL_SCREENS} {
    font-size: 32px;
    width: 100%;
  }
`)

export type HeroTextProps = {
  textWidth?: string,
  titleWidth?: string,
}

export const Text = styled('div')<HeroTextProps>( props => css`
  ${FontNormal(400)};
  ${fontSize(20)};
  margin-top: 15px;
  width: ${props.textWidth ? `${props.textWidth}` : ''};
  
  ${MQ.SMALL_SCREENS} {
    width: auto;
    margin-top: 14px;
  }
`)

export const SaveText = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(20)};
  margin-top: 15px;
  
  & > sup {
    ${fontSize(10)};
  }

  ${MQ.SMALL_SCREENS} {
    margin-top: 14px;
  }
`)

export const BottomText = styled('div')(css`
  margin-top: 11px;
  ${FontNormal(400)};
  ${fontSize(16)};
  font-style: italic;
  color: ${black};
  width: 302px;
  
  & > a {
    text-decoration: underline;
    color: ${radiantBlue};
    cursor: pointer;
  }

  ${MQ.SMALL_SCREENS} {
    width: auto;
  }
`)

export const BtnHelperText = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(16)};
  font-style: italic;
  margin-top: 6px;
  text-align: center;
`)

export const ErrorText = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(16)};
  color: ${darkRed};
  margin: 5px auto;
  position: absolute;
  text-align: center;
  width: 100%;
`)

export const getBtnStyles = (hasError: boolean) => css`
  width: 100%;
  margin-top: ${hasError ? 32 : 24}px;
`
